import { Link } from 'react-router-dom';
import './LegalLayout.css';

interface LegalLayoutProps {
  children: React.ReactNode;
}

function LegalLayout({ children }: LegalLayoutProps) {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header-content">
          <Link to="/" className="legal-header-brand">
            Vavassori Designer
          </Link>
          <Link to="/" className="legal-back-link">
            ← Voltar ao início
          </Link>
        </div>
      </header>

      <main className="legal-content">
        {children}
      </main>

      <footer className="legal-footer">
        <p>
          &copy; {new Date().getFullYear()} Vavassori Designer. Todos os direitos reservados.
          {' | '}
          <Link to="/privacidade">Privacidade</Link>
          {' | '}
          <Link to="/termos">Termos</Link>
          {' | '}
          <Link to="/cookies">Cookies</Link>
          {' | '}
          <Link to="/lgpd">LGPD</Link>
        </p>
      </footer>
    </div>
  );
}

export default LegalLayout;
